import React from 'react'

function Loading() {
    return (
        <div id="loader">
            <div className="cube-folding">
                <span className="leaf1"></span>
                <span className="leaf2"></span>
                <span className="leaf3"></span>
                <span className="leaf4"></span>
            </div>
            <p className="text-loading">پردازش برتر غرب</p>
        </div>
    )
}

export default Loading
